import PropTypes from 'prop-types'

import { STRING } from 'resources'

import ReklaimModal, { ModalHeader, ModalBody, ModalTitle } from 'components/ReklaimModal'
import { Description, ButtonsContainer, ConfirmButton, CancelButton, ErrorMessage } from './styles'

const DESCRIPTION_MAP = {
  paypal: (amountFormatted) =>
    STRING.wallet.redemptions.cashRedemption.cashRedeemPromptDescription(amountFormatted, 'PayPal'),
  venmo: (amountFormatted) =>
    STRING.wallet.redemptions.cashRedemption.cashRedeemPromptDescription(amountFormatted, 'Venmo'),
  default: (amountFormatted) => STRING.wallet.redemptions.giftCardRedemption.redeemPromptDescription(amountFormatted),
}

const RedemptionPromptModal = ({
  isOpen,
  toggle,
  amountFormatted,
  onRequestRedemption,
  isRequestingRedemption,
  errorMessage,
  accountType,
}) => {
  const description = (DESCRIPTION_MAP[accountType] || DESCRIPTION_MAP.default)(amountFormatted)

  return (
    <ReklaimModal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle} />
      <ModalBody>
        <ModalTitle>{STRING.wallet.redemptions.giftCardRedemption.redeemPromptTitle}</ModalTitle>
        <Description>{description}</Description>
        {!!errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
        <ButtonsContainer>
          <ConfirmButton onPress={onRequestRedemption} isLoading={isRequestingRedemption}>
            {STRING.wallet.redemptions.giftCardRedemption.redeemPromptConfirm}
          </ConfirmButton>
          <CancelButton onPress={toggle} variant="transparent" disabled={isRequestingRedemption}>
            {STRING.wallet.redemptions.giftCardRedemption.redeemPromptCancel}
          </CancelButton>
        </ButtonsContainer>
      </ModalBody>
    </ReklaimModal>
  )
}

RedemptionPromptModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  amountFormatted: PropTypes.string.isRequired,
  onRequestRedemption: PropTypes.func.isRequired,
  isRequestingRedemption: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,
  accountType: PropTypes.string.isRequired,
}

export default RedemptionPromptModal
